
import { computed, defineComponent, PropType, ref } from "vue";
import { useStore } from "@/store";
import { chartJsDataSet, offsetDirectionCode } from "@/types/diagram";
import { formatDdHhmmToHhmm, offsetDiagramDatas } from "@/logics/diagram";

export default defineComponent({
  props: {
    diagramDataSet: {
      type: Object as PropType<chartJsDataSet>,
      required: true,
    },
    visible: { type: Boolean, required: true },
  },
  emits: ["update:visible"],
  setup(props, context) {
    const store = useStore();

    const diagramDataSets = computed(
      () => store.getters.getChatrJsData.datasets
    );
    const selectedTrainFromTrain = ref<chartJsDataSet>();

    const offset = ref(0);

    const directions: { name: string; code: offsetDirectionCode }[] = [
      { name: "後→", code: "forward" },
      { name: "←前", code: "back" },
    ];
    const selectedDirection = ref(directions[0]);

    const localVisible = computed({
      get: () => props.visible,
      set: (value) => {
        context.emit("update:visible", value);
      },
    });
    const onClick = () => {
      if (!selectedTrainFromTrain.value) return;
      const newDiagramData = offsetDiagramDatas(
        selectedTrainFromTrain.value.data,
        offset.value,
        selectedDirection.value.code
      );
      store.dispatch("updateDiagramData", {
        id: props.diagramDataSet.id,
        data: newDiagramData,
      });
      localVisible.value = false;
    };
    const initialize = () => {
      // initialize
      offset.value = 0;
      selectedDirection.value = directions[0];
      selectedTrainFromTrain.value = undefined;
    };
    return {
      localVisible,
      onClick,
      initialize,
      diagramDataSets,
      selectedTrainFromTrain,
      offset,
      selectedDirection,
      directions,
      formatDdHhmmToHhmm,
    };
  },
});
